var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGluggaroghurdir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10.90625 2 C 10.390625 2.046875 9.996094 2.480469 10 3 L 10 47 C 10 47.550781 10.449219 48 11 48 L 39 48 C 39.550781 48 40 47.550781 40 47 L 40 3 C 40 2.96875 40 2.9375 40 2.90625 C 39.953125 2.390625 39.519531 1.996094 39 2 L 11 2 C 10.96875 2 10.9375 2 10.90625 2 Z M 12 4 L 38 4 L 38 46 L 12 46 Z M 34.5 24 C 33.671875 24 33 24.671875 33 25.5 C 33 26.328125 33.671875 27 34.5 27 C 35.328125 27 36 26.328125 36 25.5 C 36 24.671875 35.328125 24 34.5 24 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGluggaroghurdir);
export default __webpack_public_path__ + "static/media/gluggaroghurdir.38d57b69.svg";
export { ForwardRef as ReactComponent };